import React from 'react';
import SIcon from './SIcon';
import { faToggleOff } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faToggleOff} fa />;

export default Icon;
